import deUnderscore from '../utils/deUnderscore'
import asArray from '../utils/asArray'

export default function posModifierProductFieldMapFactory(taxonomyMap) {
  const mapTaxonomyToValue = (value, field) => {
    try {
      return taxonomyMap[field].filter(item => item.name === value)[0].description
    }
    catch (err) {
      return 'unknown'
    }
  }

  return {
    productCategory: function(store) {
      if (Array.isArray(this.posModifierProductCategory) && this.posModifierProductCategory.length > 0) {
        return asArray(this, 'posModifierProductCategory').map(item => mapTaxonomyToValue(item, 'pos_modifier_category')).join(", ")
      }
      else if (this.hasOwnProperty('posModifierProductCategory') && !Array.isArray(this.posModifierProductCategory)) {
        return mapTaxonomyToValue(this.posModifierProductCategory, 'pos_modifier_category')
      }
      else return 'Other Modifier Category'
    }
  }
}
